/**
 * Get payment method logo based on card type
 */
export function getPaymentMethodLogo (cardType: string = 'unknown'): string {
  const logos: Record<string, string> = {
    visa: '/icons/payments/visa.svg',
    mastercard: '/icons/payments/mastercard.svg',
    maestro: '/icons/payments/maestro.svg',
    mir: '/icons/payments/mir.svg',
    sbp: '/icons/payments/sbp.svg',
    bank_card: '/icons/card.svg',
    unknown: '/icons/card.svg',
  }

  return logos[cardType.toLowerCase()] || logos.unknown
}
